import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { TestimonialsSection } from '../components/TestimonialsSection';
export function TestimonialsPage() {
  return <main className="bg-light min-h-screen" data-id="element-1293">
      <PageBanner title="Client Testimonials" subtitle="Hear what our clients and their families have to say about our care." breadcrumbs={[{
      label: 'Testimonials',
      path: '/testimonials'
    }]} data-id="element-1294" />
      <TestimonialsSection data-id="element-1295" />
    </main>;
}